import { MDI_STATUS_NAMES } from "@repo/mdi";
import {
  CASE_STATUS,
  isWithinTerminalGracePeriod,
  type CaseStatus,
  type Case,
  type CaseListData,
} from "..";

/**
 * Maps SDK status values to our standardized case status
 */
export const mapSDKStatusToCaseStatus = (
  sdkStatus: string | undefined
): CaseStatus => {
  if (!sdkStatus) return CASE_STATUS.REQUESTED;

  const status = sdkStatus.toLowerCase();

  switch (status) {
    case MDI_STATUS_NAMES.CREATED:
      return CASE_STATUS.REQUESTED;
    case MDI_STATUS_NAMES.ASSIGNED:
    case MDI_STATUS_NAMES.APPROVED:
    case MDI_STATUS_NAMES.SUPPORT:
    case MDI_STATUS_NAMES.WAITING:
    case MDI_STATUS_NAMES.PROCESSING:
      return CASE_STATUS.ACTIVE;
    case MDI_STATUS_NAMES.CANCELLED:
    case MDI_STATUS_NAMES.CANCELED:
      return CASE_STATUS.CANCELLED;
    case MDI_STATUS_NAMES.COMPLETED:
      return CASE_STATUS.COMPLETED;
    default:
      return CASE_STATUS.REQUESTED;
  }
};

/**
 * Categorizes cases into current and past based on status.
 * Completed or cancelled cases stay in `current` for 24 hours after `updated_at`.
 */
export const categorizeCases = (cases: Case[]): CaseListData => {
  const nowMs = Date.now();

  const current = cases.filter((caseItem) => {
    const status = mapSDKStatusToCaseStatus(caseItem.case_status?.name);
    if (status === CASE_STATUS.REQUESTED || status === CASE_STATUS.ACTIVE) {
      return true;
    }
    if (status === CASE_STATUS.COMPLETED || status === CASE_STATUS.CANCELLED) {
      return isWithinTerminalGracePeriod(caseItem, nowMs);
    }
    return false;
  });

  const past = cases.filter((caseItem) => {
    const status = mapSDKStatusToCaseStatus(caseItem.case_status?.name);
    if (status !== CASE_STATUS.COMPLETED && status !== CASE_STATUS.CANCELLED) {
      return false;
    }
    return !isWithinTerminalGracePeriod(caseItem, nowMs);
  });

  return { current, past };
};
